module.exports = __webpack_public_path__ + "media/דאג.cbfeb008.mp3";